import { render } from "./cpt-image.vue?vue&type=template&id=71625c52"
import script from "./cpt-image.vue?vue&type=script&lang=js"
export * from "./cpt-image.vue?vue&type=script&lang=js"

import "./cpt-image.vue?vue&type=style&index=0&id=71625c52&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__